var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.getFooterButtonClasses = exports.getWindowOpener = exports.getLicenceIconsSrc = undefined;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Determines which icons to show, depending on the licence.


var getLicenceIconsSrc = exports.getLicenceIconsSrc = function getLicenceIconsSrc(licence) {
  var baseUrl = 'http://dxlfb468n8ekd.cloudfront.net/gsc/E5WPOE/e0/06/22/e006220d1aef4bce8a5df84e4c2cdf8a/images/buyersellerdashboard/'; // eslint-disable-line max-len

  var chooser = {
    free: 'u3711.png?token=8d593433516167ff15a5040927f9afbf',
    school: 'u3715.png?token=993e5d3da77b6e58a9a91fd645261b58',
    paid: 'u3713.png?token=127cae7b73c7874460acd89d0d4d9d60'
  };
  var image = chooser[licence];
  if (!image) return '';
  return "".concat(baseUrl, "/").concat(image);
};

var getWindowOpener = exports.getWindowOpener = function getWindowOpener(url) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(url);
  };
};

var getFooterButtonClasses = exports.getFooterButtonClasses = function getFooterButtonClasses(primary, unpurchasedPremium, secondaryGray) {
  return (0, _classnames2["default"])({
    'dashboard-card__footer__btn': true,
    'dashboard-card__footer__btn--unpurchased-premium': unpurchasedPremium,
    'tes-btn': true,
    'tes-btn--sm': true,
    'tes-btn--primary': primary,
    'tes-btn--secondary-gray-text': secondaryGray,
    'tes-btn--secondary': !primary
  });
};